import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSupabaseSession } from '../hooks/useSupabaseSession';

const BACKEND = (process.env.REACT_APP_BACKEND || 'local').toLowerCase();

export default function RequireAuth({ children }: { children: React.ReactElement }): React.ReactElement {
  const location = useLocation();
  const { session, loading } = useSupabaseSession();

  if (BACKEND !== 'supabase') return children;
  if (loading) return <div className="text-body-medium">読み込み中...</div>;
  if (session) return children;

  const from = `${location.pathname}${location.search}${location.hash}`;
  return <Navigate to="/auth" replace state={{ from }} />;
}

